import React from "react";
import ReactDOM from "react-dom/client";
import elementService from "../../../js/common/ElementService";
import { Currency } from "../../../js/common/CurrencyFormatter";
import ProductDetailPageTypeConfig, { ProductDetailInfo } from "./ProductDetailPageTypeConfig";
import productDetailInfoService from "./ProductDetailInfoService";
import ProductPriceWatchdogModal from "./components/ProductPriceWatchdogModal";

export default new class PriceWatchdogFormService {
    public init(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        for (const productPriceWatchdogContainer of document.querySelectorAll<HTMLDivElement>(".js-product-price-watchdog-container")) {
            ReactDOM.createRoot(productPriceWatchdogContainer)
                .render(<ProductPriceWatchdogModal
                    productDetailInfo={this.getProductDetailInfo(pageTypeConfig, productPriceWatchdogContainer)}
                    currency={currency}
                />);
        }
    }

    private getProductDetailInfo(pageTypeConfig: ProductDetailPageTypeConfig, productPriceRequestContainer: HTMLDivElement): ProductDetailInfo {
        return productDetailInfoService.getProductDetailInfo(
            pageTypeConfig,
            Number.parseInt(elementService.elementData(productPriceRequestContainer, "productId")),
        );
    }
}();
